import * as React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';

// Global Selectors
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';

interface ConnectedProps {
    currentEntityId?: number;
}

interface DispatchProps {
    resetSelectedTableCells: Function;
}

type Props = ConnectedProps & DispatchProps;

export class ResetSelectedTableCellsOnCurrentEntityIdUpdateComponent extends React.PureComponent<
    Props
> {
    componentDidUpdate(prevProps: Props): void {
        const { props } = this;

        if (props.currentEntityId !== prevProps.currentEntityId) {
            props.resetSelectedTableCells();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.resetSelectedTableCells();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    currentEntityId: selectCurrentEntityId
});

export default connect(
    mapStateToProps,
    {
        resetSelectedTableCells
    }
)(ResetSelectedTableCellsOnCurrentEntityIdUpdateComponent);
